import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UnderWriterFlow from "./component/pages/UnderWriterFlow";
import NewQuote from "./newcomponent/NewQuote";
import Login from "./component/pages/Login";
import { AuthProvider, useAuth } from "./context/AuthProvider";
import DashboardLibertate from "./component/pages/DashboardLibertate";
import DashboardRater from "./component/pages/DashboardRater";
import PrivateGroupRoute from "./component/common/PrivateGroupRoute";
import { NewRates } from "./newcomponent/NewRates/NewRates";
import DataUpload from "./component/pages/DataUpload";
import RaterUpload from "./component/pages/RaterUpload";
import RiskProfile from "./component/subcompo/sections-quote/RiskProfile";
import DemoRouteHandler from "./component/pages/DemoRouteHandler";
import { LibertateContextProvider } from "./context/ContextProvider";
import AmtrustUnderQues from "./component/pages/AmtrustUW";
import BookRollUpload from "./component/book-roll/upload/BookRollUpload";
import BookRollDashboard from "./component/pages/BookRollDashboard";
import { Suspense} from "react";
import { ThemeProvider, createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: "light",
  },
});

function App(props) {
  const {user: sessionData, allowedGroups: sessionGroups, isLoading} = useAuth();

  if(isLoading) return <div>Loading...</div>;

  return(
    <ThemeProvider theme={theme}>
        <LibertateContextProvider>
          <Router>
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/demo" element={<DemoRouteHandler />} />
                <Route path="/riskprofile" element={<RiskProfile />} />
                <Route
                  path="/bookupload"
                  element={
                    <PrivateGroupRoute
                      allowedGroups={[process.env.REACT_APP_BOOK_ROLL]}
                      sessionGroups={sessionGroups}
                      isLoading={isLoading}
                      sessionData={sessionData}
                    >
                      <BookRollUpload sessionData={sessionData} />
                    </PrivateGroupRoute>
                  }
                />
                <Route
                  path="/bookDashboard"
                  element={
                    <PrivateGroupRoute
                      allowedGroups={[process.env.REACT_APP_BOOK_ROLL]}
                      sessionGroups={sessionGroups}
                      isLoading={isLoading}
                      sessionData={sessionData}
                    >
                      <BookRollDashboard sessionData={sessionData} />
                    </PrivateGroupRoute>
                  }
                />
                <Route
                  path="/RaterUpload"
                  element={
                    <PrivateGroupRoute
                      allowedGroups={[process.env.REACT_APP_RATER_GROUP]}
                      sessionGroups={sessionGroups}
                      isLoading={isLoading}
                      sessionData={sessionData}
                    >
                      <RaterUpload sessionData={sessionData} />
                    </PrivateGroupRoute>
                  }
                />
                <Route
                  path="/DataUpload"
                  element={
                    <PrivateGroupRoute
                      allowedGroups={[
                        process.env.REACT_APP_UPLOAD_COMPANY,
                        process.env.REACT_APP_UPLOAD_RATER,
                      ]}
                      sessionGroups={sessionGroups}
                      isLoading={isLoading}
                      sessionData={sessionData}
                    >
                      <DataUpload sessionData={sessionData} />
                    </PrivateGroupRoute>
                  }
                />
                <Route
                  path="/Dashboard/:tab?"
                  element={
                    <PrivateGroupRoute
                      allowedGroups={[process.env.REACT_APP_DASHBOARD_GROUP]}
                      sessionGroups={sessionGroups}
                      isLoading={isLoading}
                      sessionData={sessionData}
                    >
                      <DashboardLibertate sessionData={sessionData} />
                    </PrivateGroupRoute>
                  }
                />
                <Route
                  path="/Quote"
                  element={
                    <PrivateGroupRoute
                      allowedGroups={[process.env.REACT_APP_GET_QUOTE_GROUP]}
                      sessionGroups={sessionGroups}
                      isLoading={isLoading}
                      sessionData={sessionData}
                    >
                      <NewQuote sessionData={sessionData} />
                    </PrivateGroupRoute>
                  }
                />
                <Route
                  path="/Rates"
                  element={
                    <PrivateGroupRoute
                      allowedGroups={[process.env.REACT_APP_RATER_GROUP]}
                      sessionGroups={sessionGroups}
                      isLoading={isLoading}
                      sessionData={sessionData}
                    >
                      <NewRates sessionData={sessionData} />
                    </PrivateGroupRoute>
                  }
                />
                <Route
                  path="/UwPortal/:tab?"
                  element={
                    <PrivateGroupRoute
                      allowedGroups={[process.env.REACT_APP_UW_GROUPS]}
                      sessionGroups={sessionGroups}
                      isLoading={isLoading}
                      sessionData={sessionData}
                    >
                      <UnderWriterFlow sessionData={sessionData} />
                    </PrivateGroupRoute>
                  }
                />
                <Route
                  path="/RaterDashboard"
                  element={
                    <PrivateGroupRoute
                      allowedGroups={[process.env.REACT_APP_DASHBOARD_GROUP]}
                      sessionGroups={sessionGroups}
                      isLoading={isLoading}
                      sessionData={sessionData}
                    >
                      <DashboardRater sessionData={sessionData} />
                    </PrivateGroupRoute>
                  }
                />
                <Route
                  path="/amtrustUW"
                  element={
                    <PrivateGroupRoute
                      allowedGroups={[process.env.REACT_APP_UW_GROUPS]}
                      sessionGroups={sessionGroups}
                      isLoading={isLoading}
                      sessionData={sessionData}
                    >
                      <AmtrustUnderQues sessionData={sessionData} />
                    </PrivateGroupRoute>
                  }
                />
                {/* Fallback route to prevent a completely blank page on invalid URLs */}
                <Route path="*" element={
                  <div style={{ textAlign: "center", marginTop: "50px", fontFamily: "Montserrat" }}>
                    <h2>404 - Page Not Found</h2>
                    <p>The page you are looking for does not exist.</p>
                    <a href="/">Go back to Login/Home</a>
                  </div>
                } />
              </Routes>
            </Suspense>
          </Router>
        </LibertateContextProvider>
    </ThemeProvider>
  ) ;
}

export default function AppWrapper() {
  return <AuthProvider>
    <App/>
  </AuthProvider>
};
